var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1123_21624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24134 0.598056C4.69728 0.666419 4.10765 0.934173 3.69748 1.30162C3.34142 1.6235 3.03379 2.11913 2.88852 2.60906C2.78882 2.94802 2.76034 3.57468 2.83155 3.92504C3.04803 4.98751 3.81996 5.82496 4.8454 6.1098C5.20715 6.2095 5.75406 6.23513 6.09872 6.16677C7.18967 5.94744 8.03851 5.16412 8.32051 4.11304C8.40881 3.79117 8.4259 3.19299 8.36039 2.86827C8.24075 2.28149 8.00433 1.82859 7.59415 1.41271C6.97889 0.79175 6.10726 0.486967 5.24134 0.598056ZM6.97604 1.91974C7.06434 1.96531 7.09283 2.01373 7.09283 2.12767C7.09283 2.18749 7.00168 2.29573 6.66271 2.6347L6.22975 3.06766L6.26393 3.15881C6.35508 3.42372 6.26108 3.74559 6.0389 3.93359C5.69424 4.22983 5.14449 4.10734 4.95364 3.68862C4.87389 3.51487 4.88243 3.24996 4.97073 3.07621C5.1217 2.77712 5.44927 2.62615 5.774 2.7116L5.92212 2.75148L6.32944 2.34131C6.69404 1.97101 6.79659 1.88555 6.8735 1.87986C6.88489 1.87701 6.93331 1.89695 6.97604 1.91974Z",
    fill: "#EE7225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01318 12.2686V17.8857L5.59142 17.88L6.1668 17.8715L6.17535 12.2601L6.18105 6.64862H5.59712H5.01318V12.2686Z",
    fill: "#EE7225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01994 8.01961C9.00855 8.02815 9 10.2927 9 13.0471V18.0547H14.7823H20.5647L20.559 13.0329L20.5505 8.01391H18.3999H16.2493L16.2408 9.61474L16.2351 11.2184H14.7966H13.3581V9.62613C13.3581 8.20191 13.3524 8.03385 13.3125 8.01676C13.2527 7.99397 9.04273 7.99397 9.01994 8.01961Z",
    fill: "#EE7225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61768 18.8975V19.4814H13.9148H24.2119V18.8975V18.3136H13.9148H3.61768V18.8975Z",
    fill: "#EE7225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04126 20.2698L7.04981 20.6059L8.2547 20.6144L9.45674 20.6201V20.2783V19.9365H8.24615H7.03271L7.04126 20.2698Z",
    fill: "#EE7225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3726 20.2783V20.6201H19.5831H20.7937V20.2783V19.9365H19.5831H18.3726V20.2783Z",
    fill: "#EE7225"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1123_21624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKgCase);
export default __webpack_public_path__ + "static/media/kgCase.8a1c6eed68aa1c0a95ab675d1328e662.svg";
export { ForwardRef as ReactComponent };